import axios from "axios";

/**
 * Validates a public token (unauthenticated call).
 * Returns the userId of the athlete associated with the token.
 */
export const validatePublicToken = async (token) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}public/validate-public-token`,
    { params: { token } },
  );
  return response.data;
};

/**
 * Creates or retrieves a public token for a given athlete (authenticated call).
 * Returns the token string.
 */
export const getPublicToken = async (apiInstance, athleteUserId) => {
  const response = await apiInstance.get(
    `/athlete/${athleteUserId}/public-token`,
  );
  return response.data;
};
